import React from 'react'
import { Outlet } from 'react-router-dom'
import Error404 from '../404'
import { useGetUserRole } from '../../api/auth/useGetUserRole'
import { LoadingComponent } from '@demandlocal/components'

const CheckSuperAdminAccess = (): JSX.Element => {
  const { data: user, isLoading: loading } = useGetUserRole()

  if (loading) return <LoadingComponent title={''} />

  if (Number(user?.data.role_id ?? 0) !== 1 && !loading) {
    return (
      <div className="mt-10">
        <Error404 />
      </div>
    )
  }

  return <Outlet />
}

export default CheckSuperAdminAccess
